import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Acm } from '../../../models/loyalty-acm.model';
import { Permission } from '../../../models/permission.model';
import { KontableComponent } from '../../../modules/UIKit/components/kontable/kontable.component';
import { LoyaltyAcmTypeService } from '../../../services/loyalty/loyalty-acm-type.service';
import { LoyaltyAcmService } from '../../../services/loyalty/loyalty-acm.service';
import { LoyaltyChannelService } from '../../../services/loyalty/loyalty-channel.service';
import { AuthService } from './../../../services/user/auth.service';
import { PermsService } from './../../../services/utils/perms.service';

@Component({
  selector: 'app-loyalty-acm',
  templateUrl: './loyalty-acm.component.html',
  styleUrls: ['./loyalty-acm.component.css']
})
export class LoyaltyAcmComponent implements OnInit {

  columsTitles: any;
  totalRecords = 0;
  acms: Array<Acm>;
  acmModal: Acm;
  showModalDelete: boolean;
  sortO: number;
  sortF: string;
  listChannelsSelect: Array<{value: string, label: string}>;
  listAcmTypes: Array<{value: string, label: string}>;
  listStates: Array<{value: string, label: string}>;
  listActivationStates: Array<{value: string, label: string}>;
  datePipe: DatePipe;

  private lastLoadParam: { offset: number, limit: number, search?: Array<{ key: string, value: string }> };

  // Mostra i tasti di edit, delete e recover
  public acmPermission: Permission;

  paginationType = KontableComponent.ServerPagination;
  selectFilter = KontableComponent.SelectFilter;
  customFilter = KontableComponent.CustomFilter;
  newDataAvailable = false;

  constructor(
    private translate: TranslateService,
    public acmService: LoyaltyAcmService,
    private channelService: LoyaltyChannelService,
    private acmTypeService: LoyaltyAcmTypeService,
    private router: Router,
    private authService: AuthService,
    private permissionService: PermsService
  ) { }

  ngOnInit() {
    this.sortO = 1;
    this.sortF = '';
    this.listChannelsSelect = [];
    this.listAcmTypes = [];
    this.listStates = [];
    this.listActivationStates = [];

    this.listChannelsSelect.push({ label: '', value: null });
    this.listAcmTypes.push({ label: '', value: null });
    this.listStates.push({ label: '', value: null });
    this.listActivationStates.push({ label: '', value: null });

    this.permissionService.getPermission({ms_base: 'koncentro-loyalty', operation: 'acm'}).subscribe( res => {
      this.acmPermission = res;
    });

    this.translate.get([
      'acm.channel_id',
      'acm.acm_code',
      'acm.acm_type_id',
      'acm.description',
      'common.all',
      'common.status_notDeleted',
      'common.status_onlyDeleted',
      'common.status_onlySuspended',
      'date_end',
      'date_start',
      'acm.valid',
      'acm.expired',
      'acm.future'
    ]).subscribe((translations) => {
      this.columsTitles = {
        channel_id: translations['acm.channel_id'],
        acm_code: translations['acm.acm_code'],
        acm_type_id: translations['acm.acm_type_id'],
        description: translations['acm.description']
      };

      this.listActivationStates.push({ label: translations['acm.valid'], value: 'valid' });
      this.listActivationStates.push({ label: translations['acm.expired'], value: 'expired' });
      this.listActivationStates.push({ label: translations['acm.future'], value: 'future' });

      this.listStates.push({ label: translations['common.status_notDeleted'], value: '0' });
      this.listStates.push({ label: translations['common.status_onlyDeleted'], value: '1' });
      this.listStates.push({ label: translations['common.status_onlySuspended'], value: '2' });

    });

    this.channelService.list().subscribe((res) => {
      for (const channel of res.data) {
        this.listChannelsSelect.push({value: channel.id.toString(), label: channel.channelDescription});
      }
      // Ordina alfabeticamente la lista dei canali
      this.listChannelsSelect.sort((a, b) => a.label.localeCompare(b.label));
    });

    this.acmTypeService.list().subscribe((res) => {
      for (const acmType of res.data) {
        this.listAcmTypes.push({value: acmType.description, label: acmType.description});
      }
    });
  }

  /*
    loadAcmLazy(event: LazyLoadEvent) {
      const filters = [];
      for (const filter in event.filters) {
        filters.push(
          {
            key: filter,
            value: event.filters[filter].value
          }
        );
      }
      if (event.sortField !== '') {
        filters.push({
            key: 'sort',
            value: event.sortField
          },
          {
            key: 'sort_dir',
            value: event.sortOrder
          });
      }
      this.loadPage(event.first, event.rows, filters);
    }

    loadPage (offset: number, limit: number, search?: Array<{ key: string, value: string }>) {
      this.lastLoadParam = { offset: offset, limit: limit, search: search || null};
      this.acmService.list(offset , limit, search).subscribe((res) => {
        this.acms = [];
        this.totalRecords = res.metadata.total;
        for (const singleChannel of res.data ) {

          this.acms.push(
            {
              id: singleChannel.id,
              acmDescription: singleChannel.acmDescription,
              channelDescription: singleChannel.channelDescription,
              acm_code: singleChannel.acm_code,
              acmTypeDescription: singleChannel.acmTypeDescription
            }
          );
        }
      });
    }
  */

  edit(acm: Acm) {
    this.router.navigate(['/loyalty/acm/form/' + acm.id]);
  }

  add() {
    this.router.navigate(['/loyalty/acm/form/']);
  }

  openDeleteModal(acm) {
    this.acmModal = acm;
    this.showModalDelete = true;
  }

  remove(acm) {
    this.showModalDelete = false;
    this.acmService.remove(acm.id).subscribe((res ) => {
      // this.loadPage(this.lastLoadParam.offset, this.lastLoadParam.limit, this.lastLoadParam.search);
      this.newDataAvailable = true;
    });
  }

  recover(acm) {
    this.acmService.recover(acm).subscribe((res ) => {

      this.newDataAvailable = true;
      // this.loadPage(this.lastLoadParam.offset, this.lastLoadParam.limit, this.lastLoadParam.search);

    });
  }

  changeSort(event) {
    this.sortF = event.field;
  }

  /*
  getStatus(dateStart, dateEnd): string{
    let status = null;

    let language = this.authService.sessionHelper.selectedLanguage;
    let today: string;
    if(language == "it"){
      today = this.datePipe.transform(new Date(),'dd/MM/yyyy');
    }
    else{
      today = this.datePipe.transform(new Date(),'yyyy/MM/dd');
    }

    //if(dateStart > today);
    return status;
  }
  */

  getStatus(acm): string {

    let res = null;
    let language = this.authService.sessionHelper.selectedLanguage;
    let dateStart: Date;
    let dateEnd: Date;
    let now = new Date();

    if (language == 'it') {
      // formato dd/MM/yyyy
        dateStart = new Date(acm.dateStart.substr(6, 4), +acm.dateStart.substr(3, 2) - 1, acm.dateStart.substr(0, 2));
        dateEnd = new Date(acm.dateEnd.substr(6, 4), +acm.dateEnd.substr(3, 2) - 1, acm.dateEnd.substr(0, 2));
    } else {
      // formato yyyy-MM-dd
      dateStart = new Date(acm.dateStart.substr(0, 4), +acm.dateStart.substr(5, 2) - 1, acm.dateStart.substr(8, 2));
      dateEnd = new Date(acm.dateEnd.substr(0, 4), +acm.dateEnd.substr(5, 2) - 1, acm.dateEnd.substr(8, 2));
    }

    if (dateStart <= now && dateEnd >= now) {
      res = 'valid';
    } else if (dateEnd < now) {
      res = 'expired';
    } else if (dateStart > now) {
      res = 'future';
    }

    return res;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-acm/loyalty-acm.component.ts